module.exports = __webpack_public_path__ + "static/media/12_Bild_2_ARM_Team_Imperial_NicolaPitaro_7627.a5222a15.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle12/12_Bild_2_ARM_Team_Imperial_NicolaPitaro_7627.jpg
 ** module id = 149
 ** module chunks = 0
 **/